import { Action } from "@/constants/events";
import { useEventTracker } from "@/hooks/useEventTracker";

import Button, { ButtonVariants } from "@/components/botanic/Button/Button";

export const MSOLink: React.FC<{ slug: string }> = ({ slug }) => {
  const { publishEvent } = useEventTracker();

  return (
    <Button
      data-testid="mso-finder-link"
      variant={ButtonVariants.secondary}
      className="mt-xl"
      href={`/dispensaries/locations/${slug}`}
      onClick={() =>
        publishEvent({
          action: Action.click,
          category: "Dispensary",
          label: "see all locations",
        })
      }
    >
      see all locations
    </Button>
  );
};
